module.exports = __webpack_public_path__ + "img/icon-mudedi.ca579d21.svg";